import { render, staticRenderFns } from "./FormPDICS.vue?vue&type=template&id=483547fe&scoped=true"
import script from "./FormPDICS.vue?vue&type=script&lang=js"
export * from "./FormPDICS.vue?vue&type=script&lang=js"
import style0 from "./FormPDICS.vue?vue&type=style&index=0&id=483547fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483547fe",
  null
  
)

export default component.exports